<!--
 * @Author: wangjiaxiang
 * @Date: 2022-03-28 15:06:37
 * @LastEditTime: 2022-07-07 09:32:29
 * @LastEditors: wangjiaxiang
 * @Description:
 * @FilePath: /xingmahui_front/src/views/contents/babyWikipedia/components/classification.vue
 *
-->
<template>
    <div class="classify">
      <van-sticky
        @change="change"
        :z-index="1"
        :offset-top="navHeight + searchHeight"
      >
        <div class="fixed" v-if="tagList.length > 0">
          <!-- 分类列表 -->
          <van-tabs
            :class="'isDisabled'"
            swipe-threshold="3"
            @click="articleListHander"
            v-model="active"
          >
            <van-tab
              :disabled="isDisabled"
              :title="item.name"
              v-for="(item, index) in tagList"
              :key="index"
            >
            </van-tab>
          </van-tabs>
          <!-- 分类下拉按钮 -->
          <div
            class="select-class"
            @click.stop="packUp('down')"
            v-show="!$parent.navActive"
          >
            <van-icon name="arrow-down" :size="16" />
          </div>
        </div>
      </van-sticky>

      <!-- 分类 -->
      <div class="search-class" @click.stop="packUp('up')">
        <div class="tagAllList">
          <p class="tagAlltitle">
            选择内容分类
            <span @click.stop="packUp('up')">
              <van-icon name="arrow-up" :size="16" />
            </span>
          </p>
          <div class="class-list">
            <div
              class="list-wrap"
              v-for="(item, index) in tagListTitle"
              :key="index"
            >
              <div class="big-title">
                {{ item.name }}
              </div>
              <div
                class="small-title"
                v-for="(items, index) in item.children || item.tagList"
                @click="getListHander(items.name, index)"
                :key="index"
                :class="
                  items.id == activeFnTagId &&
                  items.name == activeName
                    ? 'active'
                    : ''
                "
              >
                {{ items.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "",
  props: [
    "tagList",
    "tagListTitle",
    "navHeight",
    "searchHeight",
    "isDisabled",
    "isExpertsView",
  ],
  data() {
    return {
      active: 0, //当前点击的分类
      activeFnTagId: -1, //当前点击分类的FnTagId
      activeName: "", //当前点击分类的FnTagId
      activeModuleType: 0,
    };
  },
  watch: {
    navHeight: {
      handler(newValue, oldVal) {
        this.navHeight = newValue || 0;
      },
    },
    searchHeight: {
      handler(newValue, oldVal) {
        this.searchHeight = newValue || 0;
      },
    },
  },

  components: {},

  computed: {},

  created() {},

  mounted() {
    console.log(this.tagListTitle, 'this.tagListTitle111');
  },

  methods: {
    //  全部分类效果控制
    packUp(status) {
      if (status === "down") {
        this.$parent.suckTheTop = true;
        $("body").css({
          position: "fixed",
          top: -this.$parent.positioning + "px",
        });
        //全部分类的高
        $(".class-list").css(
          "max-height",
          document.body.clientHeight -
            ($(".tagAlltitle").outerHeight(true) + 16) +
            "px"
        );
        $(".class-list").css(
          "min-height",
          document.body.clientHeight -
            ($(".tagAlltitle").outerHeight(true) + 16) +
            "px"
        );
        $(".search-class").fadeIn(100);
        $(".tagAllList")
          .delay(50)
          .slideDown(300);

        this.scrollAddHeight();
      } else {
        $("body").css({ position: "initial", top: "auto" });
        $(window).scrollTop(this.$parent.positioning + 1);
        $(".month_search").fadeIn();
        $(".search-class").fadeOut(100);
        $(".tagAllList").slideUp(300);
      }
    },
    // 滚动距离且增加列表高度
    scrollAddHeight() {
      this.$nextTick(() => {
        // 点击展开全部分类 滚动到列表
        // if ($(".list-nav")[0].offsetTop != 0) {
        //   $("body,html").animate(
        //     { scrollTop: $(".list-nav")[0].offsetTop - this.searchHeight + 1 },
        //     500
        //   );
        // }
        // 点击分类的时候让list列表高度增加
        $(".content").css(
          "min-height",
          document.body.clientHeight -
            this.searchHeight -
            this.navHeight -
            $(".fixed").outerHeight(true) +
            1 +
            "px"
        );
      });
    },
    // 滑动分类点击
    articleListHander(name, title) {
      if (this.isExpertsView) {
        this.tagList.forEach((item, index) => {
          if (index == name) {
            console.log(item);
            this.$emit("changeTab", item);
            this.active = index;
            this.activeFnTagId = item.id || item.id;
            this.activeName = item.name;
            this.activeModuleType = item.moduleType;
          }
        });
      } else {
        this.tagList.forEach((item, index) => {
          if (item.name == title) {
            this.$emit("changeTab", item);
            this.active = index;
            this.activeFnTagId = item.id || item.id;
            this.activeName = item.name;
            this.activeModuleType = item.moduleType;
          }
        });
      }

      $(".content").css(
        "min-height",
        document.body.clientHeight -
          this.searchHeight -
          this.navHeight -
          $(".fixed").outerHeight(true) +
          1 +
          "px"
      );
    },
    // 全部分类点击
    getListHander(name, index) {
      if (this.isExpertsView) {
        this.articleListHander(index + 1, name);
      } else {
        this.articleListHander(index, name);
      }
    },
    // 吸顶触发
    change(e) {
      this.$emit("classificationSuck", e);
    },
  },
};
</script>
<style lang="less" scoped>
.fixed {
  background: #fff;
}
.classify {
  // width: 317px;
  /deep/ .van-tabs__nav--line.van-tabs__nav--complete {
    padding-left: 0 !important;
  }
  /deep/ .van-tabs__wrap--scrollable .van-tab:first-child {
    margin-left: 0 !important;
  }
  /deep/ .van-tabs--line .van-tabs__wrap {
    margin-left: 16px;
    width: 317px;
  }
}
.select-class {
  width: 38px;
  height: 42px;
  text-align: left;
  font-size: @indexFontSize18;
  position: absolute;
  top: 0px;
  right: 0;
  z-index: 1;
  margin-top: 4px;
  background: @expertFontColor255;
  i {
    margin-left: 8px;
    line-height: 44px;
  }
}
//分类
.search-class {
  display: none;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  .tagAllList {
    // padding-left: 12px;
    // padding-right: 12px;
    background: @expertFontColor255;
    .tagAlltitle {
      padding: 20px 12px 10px 12px;
      font-size: 17px;
      font-weight: bold;
      color: @expertFontColor51;
      line-height: 16px;
      display: flex;
      justify-content: space-between;
      span {
        width: 15px;
        height: 8px;
      }
    }
    .class-list {
      height: 100%;
      padding: 0 12px;
      font-size: 14px;
      font-weight: 400;
      color: @expertFontColor51;
      line-height: 14px;
      display: flex;
      flex-wrap: wrap;
      overflow-y: scroll;
      .list-wrap {
        width: 100%;
        .active {
          color: #FF67C1;
          background: #FF67C1;
        }
        .big-title {
          padding-bottom: 12px;
          color: #333;
          font-size: 14px;
          font-weight: bold;
          line-height: 16px;
        }
        .small-title {
          display: inline-flex;
          padding: 8px 12px;
          text-align: center;
          background: @expertBorderColor242;
          border-radius: 15px;
          margin-right: 12px;
          margin-bottom: 20px;
        }
      }
    }
  }
}
</style>
